import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import appConfig from '../../config/appConfig';

const initialState = {
  isAuthenticated: false,
  sessionChecked: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state) => {
      state.isAuthenticated = true;
      state.sessionChecked = true;
    },
    sessionResolved: (state, action) => {
      if (state.sessionChecked) {
        return;
      }

      state.sessionChecked = true;
      state.isAuthenticated = !!action.payload?.authenticated;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.sessionChecked = true;
      localStorage.removeItem('AUTH_TOKEN');
      Cookies.remove('token', { path: '/', domain: appConfig.cookieDomain });
    },
  },
});

export const { loginSuccess, sessionResolved, logout } = authSlice.actions;

export const selectUser = (state) => state.user?.user || {};

export default authSlice.reducer;
